import Vue from 'vue'
import Vant from 'vant';
import 'vant/lib/index.css';
/*import {Tab, Tabs, Button, Checkbox, CheckboxGroup, Sticky ,Icon,Popup } from 'vant';
import {Pagination, Sidebar, SidebarItem,Loading,Calendar,Cell} from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Skeleton } from 'vant';
import 'vant/lib/button/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/tabs/style';
import 'vant/lib/tab/style';
import 'vant/lib/sticky/style';
import 'vant/lib/pagination/style';
import 'vant/lib/checkbox/style';
import 'vant/lib/checkbox-group/style';
import 'vant/lib/skeleton/style';
import 'vant/lib/calendar/style';

Vue.use(Button);
Vue.use(Pagination);
Vue.use(Loading);

Vue.use(Tab).use(Tabs);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(Sticky);


Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Skeleton);

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Calendar)
Vue.use(Cell)
Vue.use(Icon)
Vue.use(Popup)*/



Vue.use(Vant);



// WEBPACK FOOTER //
// ./src/splitVant.js